import React from "react";
import {render} from "react-dom";
import App from "./container/App";
import {BrowserRouter} from "react-router-dom";

render(<BrowserRouter forceRefresh={true} ><App/></BrowserRouter>, document.getElementById("root"));
